import { serializeSynth } from '../stores/synthFormat.js'
import { bytesToBase64, uploadDeviceFile } from './httpTransfer.js'

export function synthDeviceFilename(synth) {
  if (!synth?.filename) return null
  return synth.filename.toLowerCase().endsWith('.synth') ? synth.filename : `${synth.filename}.synth`
}

/** Upload the production v2 serialization through the existing device file API. */
export async function deploySynthToPlate(synth, plate, upload = uploadDeviceFile) {
  if (!plate?.name) throw new Error('No active plate selected.')
  const filename = synthDeviceFilename(synth)
  if (!filename) throw new Error('The synth has no filename.')
  const text = serializeSynth(synth)
  const base64 = bytesToBase64(new TextEncoder().encode(text))
  const remotePath = `L:/${filename}`
  await upload(plate, remotePath, base64)
  return { filename, remotePath, text }
}

/** Resolve the current source-of-truth synth at the moment an Audio Resource is deployed. */
export async function deploySynthReferenceToPlate(synthId, synthStore, plate, upload = uploadDeviceFile) {
  const synth = synthStore?.getSynth(synthId)
  if (!synth) throw new Error(`Audio Resource references a missing synth (${synthId}).`)
  return deploySynthToPlate(synth, plate, upload)
}
